import _bundle from '../core/core--bundles';

// Modules
import moduleCollapsible from '../modules/module--collapsible';
import moduleAnchorsScroll from '../modules/module--anchorsScroll';
import textareaAutoHeight from '../modules/modue--textareaAutoHeight';
import menuAside from '../modules/module--menu-aside';
// import marked from '../modules/module--test';

// Nested Calls
import scrollpointsTopic from './module-calls/scrollpoints-topics';
import pageSettings from './module-calls/page-settings';
import collapsibleSparklines from './module-calls/collapsible-sparklines';
import collapsibleRemote from './module-calls/collapsible-remote';
import collapsibleTopic from './module-calls/collapsible-topic';
import collapsibleTopicHead from './module-calls/collapsible-topic-head';
import menuTopbar from './module-calls/menu-topbar';

import collapsibleMenuMainDesktop from './module-calls/collapsible-menu-main-desktop';
import collapsibleMenuMainMobile from './module-calls/collapsible-menu-main-mobile';
import collapsibleMenuMainMobileToggle from './module-calls/collapsible-menu-main-mobile-toggle';

export default function() {
    moduleAnchorsScroll.add({
        selector: '.slow-scroll',
        offset: 48 * 2, // Header height
        breakpoint: 'laptop',
        breakpointDir: 'up'
    });

    // Menus
    collapsibleMenuMainDesktop();
    collapsibleMenuMainMobileToggle();
    collapsibleMenuMainMobile();

    // Nested Calls
    scrollpointsTopic();
    pageSettings();
    menuTopbar();
    collapsibleSparklines();
    collapsibleTopic();
    collapsibleTopicHead();

    // Aside Menu, Remote Collapsibles
    const $modulelCollapsibleEl = $('.menu-topics--dynamic-collapsible');
    if ($modulelCollapsibleEl.length) collapsibleRemote($modulelCollapsibleEl);

    // Main Menu
    moduleCollapsible.add({
        block: '.dashboard-filters__dropdown',
        elToggle: '.dashboard-filters__toggle',
        elContent: '.dashboard-filters__content',
        closeOutside: true,
        closeAny: true,
        closeOthers: true,
        debug: false
    });

    moduleCollapsible.add({
        block: '.dropdown',
        elToggle: '.dropdown__toggle',
        elContent: '.dropdown__content',
        closeOutside: false,
        closeAny: false,
        closeOthers: true,
        debug: false
    });

    moduleCollapsible.add({
        block: '.topic--js',
        elToggle: '.topic__toggle',
        elContent: '.topic__content',
        closeOutside: false,
        closeAny: false,
        closeOthers: false,
        breakpoint: 'laptop',
        debug: false,
        callbackOpenAfter() {
            $('body')
                .addClass('noscroll')
                .addClass('z-index-change');
        },
        callbackCloseAfter() {
            $('body')
                .removeClass('noscroll')
                .removeClass('z-index-change');
        }
    });

    moduleCollapsible.add({
        block: '.menu-topics__dropdown',
        elToggle: '.menu-topics__dropdown-toggle',
        elContent: '.menu-topics__dropdown-content',
        closeOutside: false,
        closeAny: true,
        closeOthers: false,
        breakpoint: ['desktop'],
        speed: 250,
        debug: false
    });

    moduleCollapsible.add({
        block: '.form-footer--js',
        elToggle: '.form-footer__toggle',
        elContent: '.form-footer__content',
        closeOutside: false,
        closeAny: false,
        closeOthers: false,
        speed: 250,
        breakpoint: 'laptop',
        debug: false
    });

    // if ($('.form-item__autoheight').length) {
        textareaAutoHeight.add({
            element: '.form-item__autoheight'
        });
    // }

    moduleCollapsible.add({
        block: '.collapsible-flexgrid',
        elToggle: '.collapsible-flexgrid__toggle',
        elContent: '.collapsible-flexgrid__content',
        closeOutside: false,
        closeAny: false,
        closeOthers: false,
        matchElements($toggleClicked) {
            const $elBlock = $toggleClicked.closest('.collapsible-flexgrid');
            const $elContent = $elBlock.children('.collapsible-flexgrid__content');
            return {
                $activeBlock: $elBlock,
                $activeToggle: $toggleClicked,
                $activeContent: $elContent
            };
        },
        speed: 250,
        disableSelector: '.--no-comment.--disable', // Disable collapsible if has disable class and for an item that has no comments (Finalized Form)
        debug: false
    });

    moduleCollapsible.add({
        block: '.collapsible',
        elToggle: '.collapsible__toggle',
        elContent: '.collapsible__content',
        classOpenLoad: '--open-onload',
        closeOutside: false,
        closeAny: false,
        closeOthers: false,
        speed: 200,
        debug: false
    });

    // In Demo
    menuAside.add();
    _bundle.add({
        name: 'Refresh Aside Menu',
        event: ['on:RefreshScrollpoints'],
        fn() {
            menuAside.add();
        }
    });

    // Project Review Baseline Estimate Revisions
    menuAside.add({
        menuWrapElement: '.menu-aside--estimate-rev',
        onMenuReadyL1({ settings }) {
            const { scrollpointElement } = settings;
            $(scrollpointElement)
                .last()
                .css('margin-bottom', 'none');
        },
        onMenuReadyL2({ settings }) {
            const { collapsibleToggleRemote } = settings;
            const $section = $('#financialSumCard');
            const $toggle = $(collapsibleToggleRemote);
            const elNumbers = $('<span>', { class: 'menu-aside__item-subtotal tag tag--small' });
            $toggle.wrapInner("<span class='menu-aside__item-name'></span>");
            $toggle.append(elNumbers).addClass('justify-between items-center');

            const match = {
                collapsible_revisedPhase1: 'js-phase1-revised-estimate-total',
                collapsible_RevisedPhase2: 'js-phase2-revised-estimate-total',
                collapsible_RevisedPhase3: 'js-phase3-revised-estimate-total',
                collapsible_RevisedPhase4: 'js-phase4-revised-estimate-total',
                collapsible_RevisedPhase5: 'js-phase5-revised-estimate-total',
                collapsible_RevisedPhase6: 'js-phase6-revised-estimate-total',
                collapsible_RevisedPhase7: 'js-phase7-revised-estimate-total',
                collapsible_RevisedPhase8: 'js-phase8-revised-estimate-total',
                collapsible_RevisedPhase8A: 'js-phase8a-revised-estimate-total',
                collapsible_RevisedPhase9: 'js-phase9-revised-estimate-total',
                collapsible_RevisedTotals: 'js-total-revised-estimate-total'
            };

            Object.keys(match).forEach(function(key) {
                $(`[data-collapsible-remote-target="${key}"]`)
                    .find('.menu-aside__item-subtotal')
                    .text($section.find(`.${match[key]}`).text() || '-')
                    .addClass(match[key])
                    // I don't like this but not sure how to add this in the system that is currently there, sorry Lex, you will be missed 8/2019-3/2020
                    // gone too soon
                    .parent().parent().addClass(key === 'collapsible_RevisedTotals' ? 'border-top' : '');
            });
        }
    });
}
